import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import { PeriodeEchancier } from '../../../data/Interfaces';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { filtreListPeriodeMonthYear } from '../DashbordBackOffice';
import { statutPaiement, typeFactureList } from './InterfacesDashboards';

function ChiffreAffaire({filtreClient,chiffreAffaire,selectedClient,width,height}){

    ChiffreAffaire.propTypes = {
        chiffreAffaire:PropTypes.any,
        filtreClient: PropTypes.any,
        selectedClient:PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };
    const [selectedStatutPaiementClient, setSelectedStatutPaiementClient] = useState('all'); // Default selected period
    const [typeFacture, setTypeFacture] = useState('all'); // Default selected period
    const { i18n } = useTranslation();
    const [selectedClientCheckBoxCA, setSelectedClientCheckBoxCA] = useState(['all']);
    //const [customDateRange, setCustomDateRange] = useState({});
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 2);

    const [customDateRange, setCustomDateRange] = useState({
        from: currentDate.toISOString().slice(0, 10), // Get formatted date
        to: new Date().toISOString().slice(0, 10), // Get current date in YYYY-MM-DD format
    });
    const [selectedPeriod, setSelectedPeriod] = useState('custom'); // Default selected period
    const [chartDataChiffreAffaire,setChartDataChiffreAffaire]= useState(
        {
            series: [],
            chart: {
                type: 'line',
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    //top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.2
                },
            },
            options:{
                labels: [],

            }
        });
    const { inputSize } = useWindowSize();
    /**
         * Determine totalHtClient based on filter conditions and item properties.
         * For type 'PC', calculate only the total of extras (e.g., HNO, astreinte).
         * For type 'normal', exclude the extra frais and calculate only the normal total.
         * For other types, calculate both the extra and normal totals.
         * For client role, always return the totalHtClient without including extra fees.
    */
    const calculateSumByPeriode = (data,typeFacture) => {
        const sumByPeriode = {};

        data.forEach((item) => {
            const periode = item.periode;
            let totalHtClient;

            if (!filtreClient) {
                totalHtClient = (typeFacture == 'PC')
                    ? item.totalHtClientPrestaCompl
                    : (typeFacture == 'normal')
                        ? item.totalHtClient
                        : (item.typeFacture == 'factureG')
                            ? item.totalHtClient + item.totalHtClientPrestaCompl
                            : item.totalHtClient;
            } else {
                totalHtClient = item.totalHtClient;
            }

            // Initialize sumByPeriode entry if it doesn't exist
            if (!sumByPeriode[periode]) {
                sumByPeriode[periode] = {
                    count: 1,
                    periode: periode,
                    totalesHtClient: totalHtClient,
                };
            } else {
                // If entry exists, increment count and add to totalesHtClient
                sumByPeriode[periode].count++;
                sumByPeriode[periode].totalesHtClient += totalHtClient;
            }
        });

        return sumByPeriode;
    };

    useEffect(()=>{
        if(Array.isArray(chiffreAffaire)){
            let filteredData=chiffreAffaire;
            if(filtreClient){
                filteredData = filteredData.filter(
                    (item) => (item.typeFacture=='facture' || item.typeFacture=='factureG' || item.typeFacture=='regularisation')
                );

                if (!selectedClientCheckBoxCA.includes('all')) {
                    filteredData = filteredData.filter(
                        (item) => selectedClientCheckBoxCA.includes(item.companyDataId)
                    );
                }
            }
            if(!filtreClient){
                if (typeFacture!='all') {
                    if(typeFacture=='normal')
                        filteredData = filteredData.filter(
                            (item) => item.typeFacture=='facture' || item.typeFacture=='factureG' || item.typeFacture=='regularisation'
                        );
                    else
                        filteredData = filteredData.filter(
                            (item) => item.typeFacture=='factureX' || item.typeFacture=='factureG'|| item.typeFacture=='regularisationX'
                        );
                }
            }

            if (selectedStatutPaiementClient != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.statutPaimentClient == selectedStatutPaiementClient
                );
            }

            if(selectedPeriod)
                filteredData=filtreListPeriodeMonthYear(filteredData,selectedPeriod,customDateRange);

            const counts=calculateSumByPeriode(filteredData,typeFacture);

            setChartDataChiffreAffaire((prevState) => {
                return {
                    ...prevState,

                    series: [
                        {
                            data:Object.values(counts).map(item => typeof item.totalesHtClient === 'string'
                                ? parseFloat(item.totalesHtClient).toFixed(2)
                                : item.totalesHtClient.toFixed(2)),
                        }
                    ],

                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            type:'datetime',
                            categories: Object.keys(counts)
                        },
                    },
                };
            });
        }
    },[chiffreAffaire,customDateRange,selectedPeriod,selectedStatutPaiementClient,typeFacture,selectedClientCheckBoxCA,]);
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                {filtreClient ?
                    <h1 className='dashFrame5'> {i18n.t('Evolution chiffre d\'affaire')}</h1>
                    :
                    <h1 className='dashFrame5'> {i18n.t('Analyse budgétaire')}</h1>
                }
                <div className='filtre1'>

                    {filtreClient &&
                        <div style={{width:'33%'}}>
                            <ThemeProvider theme={FieldComponentFont}>
                                <FormControl style={{width:'100%'}}>
                                    <InputLabel
                                        shrink={true}
                                        id="demo-multiple-checkbox-label"
                                    >{i18n.t('Clients')} </InputLabel>
                                    <Select
                                        labelId="demo-multiple-checkbox-label"
                                        id="demo-multiple-checkbox"
                                        multiple
                                        value={selectedClientCheckBoxCA}
                                        onChange={(event)=>{
                                            const {
                                                target: { value },
                                            } = event;
                                            console.log('typeof value ===',typeof value === 'string' ? value.split(',') : value);
                                            setSelectedClientCheckBoxCA(
                                            // On autofill we get a stringified value.
                                                typeof value === 'string' ? value.split(',') : value,
                                            );
                                            if(value.length>0){
                                                if (value[value.length - 1] == 'all') {
                                                    setSelectedClientCheckBoxCA(['all']);
                                                } else {
                                                    // If 'all' was selected before, remove it from selectedClientCheckBox
                                                    const updatedSelected = value.includes('all')
                                                        ? value.filter((item) => item !== 'all')
                                                        : value;
                                                    console.log('updatedSelected',updatedSelected);

                                                    setSelectedClientCheckBoxCA(updatedSelected);
                                                }
                                            }
                                        }}
                                        size={inputSize}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px' },
                                        }}
                                        style={{ width: '100%', background: 'white' }}
                                        input={<OutlinedInput label="Clients" />}
                                        renderValue={(selected) => {
                                            return selected
                                                .map((id) => {
                                                    const selectedOption = selectedClient.find(
                                                        (element) => element._id === id
                                                    );
                                                    return i18n.t(selectedOption?.label);
                                                })
                                                .join(', ');
                                        }}
                                        MenuProps={MenuProps}
                                    >
                                        {Array.isArray(selectedClient) && selectedClient?.map((element) => (
                                            <MenuItem
                                                key={element._id}
                                                value={element._id}
                                            >
                                                <Checkbox checked={selectedClientCheckBoxCA.includes(element._id)} />
                                                <ListItemText primary={i18n.t(element.label)} />
                                            </MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </ThemeProvider>
                        </div>
                    }
                    {!filtreClient &&
                    <div style={{width:'33%'}}>
                        <SelectComponent
                            label={i18n.t('Type Facture')}
                            val={typeFacture}
                            name='Type Facture'
                            setVal={(e) => {
                                setTypeFacture(e.target.value);
                            }}
                            listVal={typeFactureList}
                        />
                    </div>
                    }
                    <div style={{width:'33%'}}>
                        <SelectComponent
                            label={i18n.t('Statut paiement/Client')}
                            val={selectedStatutPaiementClient}
                            name='Statut paiement/Client'
                            setVal={(e) => {
                                setSelectedStatutPaiementClient(e.target.value);
                            }}
                            listVal={statutPaiement}
                        />
                    </div>

                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod}
                            setSelectedPeriod={setSelectedPeriod}
                            setCustomDateRange={setCustomDateRange}
                            listeVal={PeriodeEchancier}
                        />
                    </div>
                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataChiffreAffaire.options}
                        series={chartDataChiffreAffaire.series}
                        type="line"
                        width={'100%'}
                        height={'85%'}
                    />
                </div>
            </div>
        </>
    );

}
export default ChiffreAffaire;